import "../../Projects/LosPistoleros/lospistoleros.css";
import Hero from "../../Projects/LosPistoleros/Hero.jsx";
import AboutUs from "../../Projects/LosPistoleros/AboutUs.jsx";
import Post1 from "../../Projects/LosPistoleros/Post1.jsx";
import Post2 from "../../Projects/LosPistoleros/Post2.jsx";
import Post3 from "../../Projects/LosPistoleros/Post3.jsx";

import Footer from "../../general/Footer.jsx";

export default function LosPistoleros() {
  return (
    <div className="los-pistoleros-page">
      <Hero />
      <AboutUs />
      <Post1 />
      <Post2 />
      <Post3 />
      <Footer />
    </div>
  );
}
